import {createElement, Component, PropTypes} from 'rlink-react';
import StringInput from './StringInput';


export default class EmailInput extends StringInput {
  get inputType () {
    return 'email';
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/EmailInput.jsx